import Background from '@anm/components/Background';
import TitleBlock from '@anm/components/TitleBlock';
import { TitleDescription } from '@anm/components/TitleBlock/Wrapper';
import { media, stretchToScreenHeight } from '@anm/styles/helpers';
import styled from 'styled-components';

const recoveryContainerOnMobiles = media.tablet`
  padding: 30px 10px;
  justify-content: center;
`;

const formOnMobiles = media.tablet`
  margin: 20px auto;
`;

const recoveryTitleOnMobiles = media.tablet`
  font-size: 28px;
  line-height: 28px;
`;

const recoverySubtitleOnMobiles = media.tablet`
  font-size: 18px;
  line-height: 24px;
`;

export const RecoveryContainer = styled(Background)`
  display: flex;
  flex: 1;
  width: 100%;
  justify-content: flex-start;
  padding: 60px 0;
  align-items: center;
  text-align: center;
  color: #292a2b;
  flex-direction: column;
  ${stretchToScreenHeight};
  ${recoveryContainerOnMobiles};
`;

export const RecoveryFormWrapper = styled.form`
  ${formOnMobiles};

  min-height: 215px;
  max-width: 340px;
  margin: 31px auto 0;
  width: 100%;

  button {
    margin-top: 10px;
  }
`;

export const RecoveryTitleBlock = styled(TitleBlock)`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    ${recoveryTitleOnMobiles};

    font-size: 40px;
    font-weight: 700;
    line-height: 50px;
    margin-bottom: 20px;
    margin-top: 0;
  }

  ${TitleDescription} {
    ${recoverySubtitleOnMobiles};

    font-size: 20px;
    font-weight: 300;
    line-height: 32px;
    margin: 0;
  }
`;
